import React from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-50% - 15px));
  }
`;

const CarouselContainer = styled.div`
  width: 100%;
  position: relative;

  z-index: 2;

  overflow: hidden;
  padding: 16px 0px 48px;
`;

const CarouselInner = styled.div`
  display: flex;
  width: fit-content;
  animation: ${scroll} 30s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

const CarouselTrack = styled.div`
  display: flex;
  gap: 30px;
  padding: 10px 0;
`;

const CardContainer = styled.div`
  display: flex;
  padding: 0 30px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }

  @media (max-width: 480px) {
    padding: 0 15px;
  }
`;

const Card = styled.div`
  width: 220px;
  height: 120px;
  margin: 0 30px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);

  @media (max-width: 1024px) {
    width: 200px;
    height: 110px;
    margin: 0 25px;
    border-radius: 16px;
  }

  @media (max-width: 768px) {
    width: 180px;
    height: 100px;
    margin: 0 20px;
    border-radius: 14px;
  }

  @media (max-width: 480px) {
    width: 150px;
    height: 85px;
    margin: 0 15px;
    border-radius: 12px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.8),
      transparent
    );
    transition: 0.5s;
  }

  &:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 0, 0, 0.12);

    &::before {
      left: 100%;
    }

    img {
      filter: brightness(1.05) contrast(1.05);
      transform: scale(1.05);
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 15px;
    filter: brightness(1) contrast(1);
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      padding: 12px;
    }

    @media (max-width: 480px) {
      padding: 10px;
    }
  }
`;
function AutoCarousel({
  images = ["blue.png", "del.png", "ekart.png", "express.png", "shadow.png"],
}) {
  return (
    <CarouselContainer>
      <CarouselInner>
        {/* First set of images */}
        <CarouselTrack>
          {images.map((image, index) => (
            <CardContainer key={`first-${image}-${index}`}>
              <Card>
                <img src={`/images/${image}`} alt={`Partner ${index + 1}`} />
              </Card>
            </CardContainer>
          ))}
        </CarouselTrack>

        {/* Second set of images for seamless loop */}
        <CarouselTrack>
          {images.map((image, index) => (
            <CardContainer key={`second-${image}-${index}`}>
              <Card>
                <img src={`/images/${image}`} alt={`Partner ${index + 1}`} />
              </Card>
            </CardContainer>
          ))}
        </CarouselTrack>
      </CarouselInner>
    </CarouselContainer>
  );
}

AutoCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
};

AutoCarousel.defaultProps = {
  images: ["blue.png", "del.png", "ekart.png", "express.png", "shadow.png"],
};

export default AutoCarousel;
